import {gql} from '@apollo/client';
import {useMutation$} from 'graphqlsupport';
import {Offer} from 'offer';
import {useCallback} from 'react';
import {useDomainErrorDialog} from '../../common/component/ErrorDialog';
import {sanitizeOfferInput, OfferFormInput} from '../component/OfferForm';
import {OfferContentFragment, StatusAndSubmitter} from '../domain/graphql';


type NewOfferMutationInput = {
    referralGuid: string;
    providerGuid: string;
    offerInput: OfferFormInput;
}
type NewOfferMutationResult = {
    submitNewOffer: Partial<Offer>;
};
const NEW_OFFER_CLIENT_PLACEMENT_MUTATION = gql`
mutation (
    $referralGuid: String!, 
    $providerGuid: String!, 
    $offerInput: OfferContentInput
) {
  submitNewOfferClientPlacement(
    referralGuid: $referralGuid
    providerGuid: $providerGuid
    payload: $offerInput
  ) {
    id
    guid
    ...${OfferContentFragment.name}
    ...${StatusAndSubmitter.name}
  }
}
${OfferContentFragment.value}
${StatusAndSubmitter.value}
`;
export const useSubmitNewOfferClientPlacement$ = (
    referralGuid: string,
    onSuccess: (newOffer: Partial<Offer>) => any
) => {
    const {
        isRunning$,
        execute,
        data,
    } = useMutation$<NewOfferMutationInput, NewOfferMutationResult>(NEW_OFFER_CLIENT_PLACEMENT_MUTATION);

    const {errorMessage$, tryParsingDomainError} = useDomainErrorDialog();

    const submitOffer = useCallback(async (content: OfferFormInput) => {
        try {
            const {data: result} = await execute({
                variables: {
                    referralGuid,
                    providerGuid: content.providerGuid ?? "",
                    offerInput: sanitizeOfferInput(content),
                }
            });
            if (!!result) {
                onSuccess(result.submitNewOffer);
            }
        } catch (e) {
            if (!tryParsingDomainError(e)) {
                throw e;
            }
        }
    }, [execute, referralGuid, onSuccess, tryParsingDomainError]);

    return {
        isRunning$,
        execute: submitOffer,
        data,
        errorMessage$,
    };
};
